import branding from 'shared/app/model/branding';
var DispatcherModeName;
(function (DispatcherModeName) {
    DispatcherModeName["in_paid_tariff"] = "in_paid_tariff";
    DispatcherModeName["always"] = "always";
})(DispatcherModeName || (DispatcherModeName = {}));
export function dispatcherModeEnabled() {
    if (branding.dispatcher_mode_visible == DispatcherModeName.in_paid_tariff) {
        return true;
    }
    if (branding.dispatcher_mode_visible == DispatcherModeName.always) {
        return true;
    }
    return false;
}
